"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var classnames_1 = __importDefault(require("classnames"));
var FormControlLabel_1 = __importDefault(require("../Form/FormControlLabel"));
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    radioBtn: {
        width: theme.spacing(4),
        height: theme.spacing(4),
    }
}); });
var Radio = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, checkedIcon = _a.checkedIcon, checked = _a.checked, disabled = _a.disabled, disableRipple = _a.disableRipple, icon = _a.icon, _d = _a.size, size = _d === void 0 ? 'medium' : _d, id = _a.id, inputProps = _a.inputProps, inputRef = _a.inputRef, onChange = _a.onChange, required = _a.required, value = _a.value, label = _a.label, _e = _a.labelPlacement, labelPlacement = _e === void 0 ? 'end' : _e, onClick = _a.onClick;
    var internalClasses = useStyles();
    var _f = classes.formControlLabel, labelClasses = _f === void 0 ? {} : _f, _g = classes.checkbox, checkboxClasses = _g === void 0 ? {} : _g;
    return (react_1.default.createElement(FormControlLabel_1.default, { classes: __assign(__assign({}, labelClasses), { label: (0, classnames_1.default)(labelClasses.label || '') }), control: react_1.default.createElement(Radio_1.default, __assign({ classes: __assign(__assign({}, checkboxClasses), { root: (0, classnames_1.default)(internalClasses.radioBtn, checkboxClasses.root || '') }), color: color }, checkedIcon ? { checkedIcon: checkedIcon } : {}, icon ? { icon: icon } : {}, { checked: checked, disabled: disabled, disableRipple: disableRipple, size: size, id: id, inputProps: inputProps, inputRef: inputRef, onChange: onChange, onClick: onClick, required: required, value: value })), label: label, labelPlacement: labelPlacement }));
};
exports.default = Radio;
